import "bootstrap";
import { _ } from "../../polyglot/polyglot.js";
import { convertRenderableToHTML } from "../../helpers/dom-util.js";
import { htmlCanvas } from "@foretagsplatsen/widgetjs";
import AlertMessageWidget from "../AlertMessageWidget/AlertMessageWidget.js";
import jQuery from "jquery";

let nextId;

(function () {
	let id = 0;

	nextId = function () {
		return `popover-id-${id++}`;
	};
})();

// TODO: Refactor this class.  We currently use bootstrap's popover
// templates to render & position the widget, then re-render it using the
// htmlCanvas. We need to rewrite this to avoid the html string template &
// re-rendering hack.

/**
 * `popoverWidget` is a bootstrap popover wrapper.
 * It is used to build a popover displayed when a defined trigger is activated.
 *
 * It supports any renderable object for header, content and footer.
 * Build on top of Bootstrap popovers [http://getbootstrap.com/javascript/#popovers]
 *
 * @param {{}} spec - Parameter object
 * @param {widget} spec.triggerItem - Item used to position the popover. It is also used to check the trigger
 * @param {string} [spec.trigger] - Trigger used to toggle the popover visibility. Value can be 'click', 'hover', 'focus' or 'manual'
 * @param {string} [spec.placement] - Rule to position the popover. Value
 *   can be 'top', 'bottom', 'left', 'right', 'auto'. Multiple values can be
 *   provided separated by spaces.
 * @param {Renderable} [spec.header] - Renderable object used to render the popover header.
 * @param {Renderable} [spec.content] - Renderable object used to render the popover body.
 * @param {Renderable} [spec.footer] - Renderable object used to render the popover footer.
 * If false, no footer. Otherwise a default footer is used unless a footer is specified.
 * @param {boolean} [spec.showFooterDivider] - Show a horizontal divider line before the footer.
 * @param {string} [spec.popoverCssClass] - Css class of the popover DOM element.
 * @param {string} [spec.primaryLabel] - Label for primary action if default footer is used
 * @param {function} [spec.primaryAction] - Primary action if default footer is used
 * @param {string} [spec.viewport] - Keeps the popover within the bounds of this element
 * @param {string} [spec.isPrimaryActionEnabled] - Flag to disable the primary action button
 * @param {string} [spec.primaryActionDisabledMessage] - Message to display when the primary action is disabled
 * @param {function} [spec.closeAction] - Executed when clicking on the close popover link
 * @param {Renderable} [spec.closeLabel] - Rendered as the close popover link
 * @param {number[]} [spec.offset] - Array of px to offset the popover. First
 *   value is for horizontal offset. Second value is for vertical offset. If
 *   the second value is omitted, the first value will be used instead
 * @param {object} my - protected fields holder
 * @return {{}}
 */
function popoverWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = {};

	let triggerItem = spec.triggerItem; // This is a brush, not a JQuery object!
	const trigger = spec.trigger || "click";
	const placement = spec.placement || "auto";
	const header = spec.header;
	const content = spec.content;
	const footer = spec.footer === false ? false : spec.footer || defaultFooter;
	const showFooterDivider = spec.showFooterDivider !== false;
	const offset = spec.offset;

	const primaryLabel = spec.primaryLabel;
	const primaryAction = spec.primaryAction;
	const isPrimaryActionEnabled =
		spec.isPrimaryActionEnabled === undefined
			? true
			: spec.isPrimaryActionEnabled;
	const primaryActionDisabledMessage =
		spec.primaryActionDisabledMessage ||
		_("{primaryLabel} is unavailable.", { primaryLabel });

	const popoverCssClass = spec.popoverCssClass || "popover fade top";
	const popoverId = nextId();

	const container = spec.viewport || "#document";
	const viewport = spec.viewport === undefined ? "#viewport" : spec.viewport;
	const animation = spec.animation !== false;
	const closeAction = spec.closeAction || (() => {});
	const closeLabel = spec.closeLabel || _("Close");

	that.setTriggerItem = function (newTrigger) {
		let oldPopover;
		if (triggerItem) {
			triggerItem.asJQuery().removeClass("clickable");
			oldPopover = triggerItem.asJQuery().data("bs.popover");
		}
		triggerItem = newTrigger;
		triggerItem.asJQuery().addClass("clickable");

		if (oldPopover) {
			triggerItem.asJQuery().data("bs.popover", oldPopover);
			registerCloseOnClick();
			return;
		}

		setup();
	};

	that.asJQuery = function () {
		return jQuery(`#${popoverId}`).parent();
	};

	that.show = function () {
		if (!triggerItem) {
			return;
		}
		triggerItem.asJQuery().popover("show");
	};

	that.hide = function () {
		if (!triggerItem) {
			return;
		}
		triggerItem.asJQuery().popover("hide");
	};

	my.fillPopoverContent = function () {
		const $popover = that.asJQuery();

		const contentCanvas = htmlCanvas($popover.find(".popover-content"));
		contentCanvas.root.asJQuery().empty();
		contentCanvas.render(content || "");

		if (header) {
			const headerCanvas = htmlCanvas($popover.find(".popover-title"));
			headerCanvas.root.asJQuery().empty();
			headerCanvas.render(header);
		}

		if (footer) {
			const footerCanvas = htmlCanvas($popover.find(".footer"));
			footerCanvas.root.asJQuery().empty();
			footerCanvas.render(footer);
		}
	};

	my.offsetPopover = function () {
		if (!offset) return;
		const popover = that.asJQuery().get(0);
		popover.style.transform = `translate(${offset[0]}px, ${offset[1] ?? offset[0]}px)`;
	};

	my.unOffsetPopover = function () {
		if (!offset) return;
		const popover = that.asJQuery().get(0);
		if (!popover) return;

		popover.style.transform = "";
	};

	my.resetPopoverState = function () {
		const popover = triggerItem?.asJQuery().data("bs.popover");
		if (!popover) return;

		// https://github.com/twbs/bootstrap/issues/16732#issuecomment-165229037
		popover.inState = { click: false, hover: false, focus: false };
	};

	my.createTemplate = function () {
		let template = `<div class="${popoverCssClass}"><div id="${popoverId}"></div><div class="arrow"></div>`;

		let footerHTML;
		if (header) {
			template += '<h3 class="popover-title"></h3>';
		}

		if (content) {
			template += '<div class="popover-content"></div>';
		}

		if (footer) {
			footerHTML = convertRenderableToHTML(footer);
			template += `<div class="footer">${footerHTML}</div>`;
		}

		template += "</div>";

		return template;
	};

	my.createContent = function () {
		let html;

		if (content) {
			html = convertRenderableToHTML(content);
		}

		return html;
	};

	my.createTitle = function () {
		if (!header) {
			return "";
		}

		return convertRenderableToHTML(header);
	};

	function defaultFooter(html) {
		if (showFooterDivider) {
			html.div({ class: "popover-divider" });
		}

		if (!isPrimaryActionEnabled) {
			html.render(
				new AlertMessageWidget({
					type: "warning",
					content: primaryActionDisabledMessage,
				}),
			);
		}

		html.div({ class: "text-center" }, (html) => {
			html.a(
				{
					class: "btn btn-link popover-close",
					"data-test": "close",
					click: () => {
						that.hide();
						closeAction();
					},
				},
				closeLabel,
			);

			if (primaryAction && primaryLabel) {
				html.a(
					{
						class: [
							"btn",
							"btn-primary",
							{ disabled: !isPrimaryActionEnabled },
						],
						"data-test": "apply",
						click: () => {
							if (!isPrimaryActionEnabled) return;
							that.hide();
							primaryAction();
						},
					},
					primaryLabel,
				);
			}
		});
	}

	function setup() {
		let popover;
		if (triggerItem) {
			popover = triggerItem.asJQuery().popover({
				animation,
				trigger,
				placement,
				title: my.createTitle,
				template: my.createTemplate(),
				html: true,
				viewport,
				container,
				content: my.createContent,
			});

			popover.on("inserted.bs.popover", my.fillPopoverContent);

			popover.on("shown.bs.popover", () => {
				my.offsetPopover();
				registerCloseOnClick();
			});

			popover.on("hide.bs.popover", my.unOffsetPopover);

			popover.on("hidden.bs.popover", my.resetPopoverState);
		}
	}

	/**
	 * Make a click outside the popover close the popover.
	 */
	function registerCloseOnClick() {
		const callback = (clickEvent) => {
			const clickTarget = clickEvent.target;

			if (!clickTarget) return;

			const popoverElement = that.asJQuery().get(0);

			const clickWithinPopover = isElementChildOf({
				element: clickTarget,
				target: popoverElement,
			});

			const clickWithinTriggerItem = isElementChildOf({
				element: clickTarget,
				target: triggerItem.element,
			});

			if (clickWithinPopover || clickWithinTriggerItem) return;

			that.hide();
		};

		// Wait a bit before activating the auto-close behavior. This
		// is to make sure that double-click events on the trigger
		// doesn't immediately close the popover:
		setTimeout(
			() =>
				document.body.addEventListener("click", callback, {
					capture: true,
					once: true,
				}),
			0,
		);
	}

	// Init
	setup();

	return that;
}

function isElementChildOf({ element, target }) {
	if (!element) {
		return true;
	}

	if (element === document.body) {
		return target === document.body;
	}

	return (
		element === target ||
		isElementChildOf({ element: element.parentElement, target })
	);
}

export default popoverWidget;
